import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donation-setup/seva";

export const Route = createFileRoute("/admin/_donation-setup/seva")({
  component: Page,
});
